import { useState, useEffect, useContext, useRef } from 'react'
import { useForm } from 'react-hook-form'
import Modal from 'react-modal'
import axios from 'axios'
import axio from 'axios'
import Loading from './Loading'
import { projectContext, loadingContext, unfolder, onImportExcelAsync } from '../lib'
import { urlValue } from '../lib'
import '../styles/styles.css'
import '../styles/newProjectModal.scss'
import { customModal } from '../styles/customModal'
import * as XLSX from 'xlsx';
import AWS from 'aws-sdk'
import { Tooltip, } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import ButtonYesNo from './common/ButtonYesNo'
import BoxInfo from './common/BoxInfo'
import { InputNesting } from './common/Inputs/Input'
import { SelectNesting } from './common/Inputs/Select'

export default function NewProjectView({ isModalOpen, closeModal, onClose }) {
  const [loading, setLoading] = useContext(loadingContext)
  const [campaings, setCampaings] = useState([])
  const [voices, setVoices] = useState([])
  const [radomVoice, setRadomVoice] = useState(false)
  const [listLanguage, setListLanguage] = useState([])
  const [ProjectExcel, setProjectExcel] = useState([])
  const [loadingUpload, setLoadingUpload] = useState(false)
  const [subCampaings, setSubCampaings] = useState([])
  const [useDefaultSentiment, setUseDefaultSentiment] = useState(0);
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [hold, setHold] = useState(true)
  const [nlp_configName, setNlp_configName] = useState("Upload");
  const [imageName, setImageName] = useState("Upload");
  const [image, setImage] = useState(null);
  const [nlp_config, setNlp_config] = useState(null);
  const [error, setError] = useState({ name: "" })
  const [channel, setChannel] = useState("voice")
  const [category, setCategory] = useState('outbound');
  const [transcription, setTranscription] = useState(0);
  const timeHoldRef = useRef();
  const minimunCallDurations = useRef();
  const maxUserResponseTime = useRef();
  const timeHoldAmountRef = useRef();
  const language = useRef();
  const campaingRef = useRef()
  const subCampaingRef = useRef()
  const affectation_time_ref = useRef();
  const percentage_affectation_ref = useRef();
  const bot_respose_time_ref = useRef();
  const fileString = ''
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()

  const fetchCampaing = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

    try {
      const url = `${urlValue}/studio/project/camp/campaing`;
      const rest = await axio.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });

      if (rest.status === 200 && rest.data) {
        setCampaings(rest.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchVoice = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    // setLoading(true)
    try {
      const url = `${urlValue}/studio/project/voices/all`;
      const rest = await axio.get(url, {
        headers: {
          user: id,
          language: language?.current?.value.substring(0, 2)  || 'EN',
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });
      
      if (rest.status === 200 && rest.data) {
        setVoices(rest.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchSubCampaing = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

    try {
      const url = `${urlValue}/studio/project/camp/sub-campaing`;
      const rest = await axio.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });

      if (rest.status === 200 && rest.data) {
        setSubCampaings(rest.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchLanguage = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    // setLoading(true)
    try {
      const url = `${urlValue}/studio/language`;
      const rest = await axio.get(url, {
        headers: {
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });

      if (rest.status === 200 && rest.data) {
        setListLanguage(rest.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    fetchCampaing();
    fetchSubCampaing();
    fetchLanguage();
    fetchVoice();
  }, [])

  const convertToBase64 = (file) => {
    return new Promise(resolve => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result);
      }
    })
  }

  const onSubmit = async data => {

    let ok = true
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token

    const nlp_config_file_url = URL.createObjectURL(nlp_config);
    const getJson = await fetch(nlp_config_file_url);
    const json_nlp_text = await getJson.text();
    const json_nlp = JSON.parse(json_nlp_text);

    if (nlp_config) {
      if (!json_nlp.hasOwnProperty("type")) {
        setError({ ...error, name: "The json file is not valid" })
        ok = false;

      }
    } else {
      setError({ ...error, name: "Json file is required" })
      ok = false;

    }


    const exp = /^[A-Za-z0-9-,._'¿?\s]+$/g;
    if (!exp.test(data.name)) {
      ok = false;
      setError({ ...error, name: "The name cannot contain symbols and special characters." })
    }

    if (ok) {
      let convertedFile = ""
      if (image) {
        convertedFile = await convertToBase64(image)
      }

      const dataSend = {
        name: data.name,
        //Se cambio a null temporalmente hasta la primera entrega despues agregar id de cada nlp Dlowflow RASA
        nlp: 1,
        nlp_config: json_nlp,
        nlp_url: 'localhost',
        metadata: { "description": data.metadata, "language": language.current.value },
        //Se cambio a null temporalmente hasta la primera entrega despues /agregar la imagen
        image: { "imageName": imageName, "url": "" } || null,
        imageFile: convertedFile || null,
        time_hold_amount: timeHoldAmountRef.current?.value || 0,
        time_hold_seconds: timeHoldRef.current?.value || 0,
        use_hold: hold ? 1 : 0,
        campaing: campaingRef.current?.value,
        sub_campaing: subCampaingRef.current?.value,
        url_tp_simulation: data.url_tp_simulation,
        voice: document.querySelector("#voice").value,
        random_voice: radomVoice ? 1 : 0,
        use_default_sentiment: useDefaultSentiment,
        channel: channel,
        transcription: transcription,
        min_call_time: minimunCallDurations.current?.value || 0,
        max_user_response_time: maxUserResponseTime.current?.value || 0,
        bot_response_time: bot_respose_time_ref.current?.value || 0,
      }

      let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

      axios({
        method: 'post',
        url: `${urlValue}/studio/project`,
        headers: {
          user: id,
          'access-token': token,
        },
        data: dataSend,
        // data: formDataImage
      })
        .then(function (response) {
          onClose()
          setLoading(false)
          window.location.reload();
        })
        .catch(function (error) {
          onClose()
          setLoading(false)
        })
    }
  }

  const uploadMaxive = async () => {

    if (!loadingUpload && ProjectExcel.length > 0 && ProjectExcel.length <= 51) {

      setLoadingUpload(true)
      setTimeout(async () => {

        let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
        let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        for (var i = 0; i < ProjectExcel.length; i++) {
          const dataSend = {
            name: ProjectExcel[i].Name?.trim(),
            //Se cambio a null temporalmente hasta la primera entrega despues agregar id de cada nlp Dlowflow RASA
            nlp: 1,
            nlp_config: JSON.parse(ProjectExcel[i].Motor_Congnitivo),
            nlp_url: 'localhost',
            metadata: { "description": ProjectExcel[i].Description, "language": ProjectExcel[i].Language },
            //Se cambio a null temporalmente hasta la primera entrega despues /agregar la imagen
            image: null,
            time_hold_amount: ProjectExcel[i].Hold_Attempts_per_call || 0,
            time_hold_seconds: ProjectExcel[i].Hold_Time_Seconds || 0,
            use_hold: ProjectExcel[i].Use_hold_time === 1 ? 1 : 0,
            campaing: ProjectExcel[i].Campaign,
            sub_campaing: ProjectExcel[i].SubCampaign

          }

          const rest = await axios.post(`${urlValue}/studio/project`, dataSend, {
            headers: {
              user: id,
              'access-token': token,
            }
          })
        }
        setLoadingUpload(false);
        window.location.reload();
      }, 1000)

    } else {
      alert("Cannot insert more than 50 lines")
    }

  }
  const prepareExcel = async (e) => {
    const DatosExcel = await onImportExcelAsync(e);
    setProjectExcel(DatosExcel)
  }

  const ChangeModelSentiment = (e) => {
    if (e.target.value === 'Voice') {
      selectedProject.bot_sentiment = 0;
    }
  }

  const saveBotSentimentConfig = function (e) {

    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token

    axios({
      method: 'post',
      url: `${urlValue}/studio/project/${selectedProject.id}/bot_sentiment`,
      headers: {
        user: id,
        'access-token': token,
      },
      data: {
        bot_sentiment: e.target.value,
      }
    }).then(function (res) {
    }).catch(error => {
      console.log('Error to try update bot sentiment: ', error);
    })
  }

  return (

    <div className="newProject-modal modal-cont ">
      <h1>Create Project</h1>
      <form onSubmit={handleSubmit(onSubmit)} className="w-100">
        <div className="scroll-internal-modal sm7-h-50vh sm6-h-50vh sm5-h-70vh sm4-h-70vh sm3-h-70vh h-80 " >
          <div className="d-flex flex-row justify-space-between  "  >
            <div className="d-flex flex-column" style={{ width: '45%' }}>
              <div className="inputs" id="name">
                <div className="input tooltip">
                  <span>Name:</span>
                  <input placeholder='Enter the name to assign to the new project' className='input-data' id='name' {...register('name', { required: true })} type="text" />
                  <Tooltip anchorId="name" content={`Only these characters are accepted A-Za-z0-9-,._'¿?`} place="top" />
                  {/* <span className="tooltiptext"><div className='triangulo'></div></span> */}
                </div>
              </div>
              <div className="inputs" style={{ marginTop: 20 }} id="image">
                <div className="input">
                  <div className="flex items-center">
                    <span>Image</span>
                    <img id="image-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting  " alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#image-tp" content={`Here you can add an image to personalize your Project visualization `} place="top" />
                  </div>
                  <label className="custom-file">
                    <input
                      onChange={(e) => { setImage(e.target.files[0]); setImageName(e.target.files[0].name) }}
                      // onChange={e => fileUploadHandler(e)}
                      type="file"
                      accept="image/png, .jpeg, .jpg"
                    />
                    {imageName}
                  </label>
                </div>
              </div>
              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input">
                  <span>Description</span>
                  <textarea placeholder='Enter a detailed description of the new project' rows={3} {...register('metadata', { required: true })} />
                </div>
              </div>
              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input" id="welcoming_message">
                  <span>Welcoming Message</span>
                  <textarea placeholder='Type the message that will greet users when the interaction begins' className='' rows={3} {...register('welcoming_message', { required: false })} />
                </div>
              </div>
              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input" >
                  <span>URL TP Simulation</span>
                  <input className='input-data' placeholder='Enter the website address for the TP Simulation to be added' {...register('url_tp_simulation', { required: false })} type="text" />
                </div>
              </div>


              <div className="inputs" style={{ marginTop: 25 }}>
                <div className="input d-flex flex-row align-items-center" style={{ alignItems: "center", flexDirection: "row" }}>
                  <div className="flex items-center">
                    <span>Bot Type:</span>
                    <img id="bottype-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-5 cursor-pointer tooltip-nesting  " alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#bottype-tp" content={`Here you can select your bot type between outbound or inbound`} place="top" />
                  </div>
                  <div className="ml-2 list_bot_type d-flex flex-row align-items-center" >
                    <ButtonYesNo
                      onClick={() => setChannel((prev) => prev === "voice" ? "chat" : "voice")}
                      width={170}
                      state={channel === "chat" ? false : true}
                      height={30}
                      Yes='Voice Bot'
                      No='Chat Bot'
                    />
                  </div>
                </div>
              </div>

              <div className="inputs" style={{ marginTop: 20 }} >
                <div className="input d-flex flex-row align-items-center" style={{ alignItems: "center", flexDirection: "row" }}>
                  <span>Interaction Type:</span>
                  <div className="list_call_type ml-2 d-flex flex-row align-items-center">
                    <ButtonYesNo
                      onClick={() => setCategory((prev) => prev === "outbound" ? "inbound" : "outbound")}
                      width={170}
                      state={category === "outbound" ? false : true}
                      height={30}
                      Yes='Inbound'
                      No='Outbound'
                    />
                  </div>
                </div>
              </div>

              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input d-flex flex-row align-items-center" style={{ alignItems: "center", flexDirection: "row" }}>
                  <span>Transcription Enable:</span>
                  <img id="transcriptionenable-tp" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting  " alt="" />
                  <Tooltip openOnClick={true} anchorSelect="#transcriptionenable-tp" content={`Activate or deactivate the transcription of the interaction `} place="top" />	
                  <div className="list_transcription_enable ml-2 d-flex flex-row align-items-center">
                    <ButtonYesNo
                      onClick={() => setTranscription((prev) => prev === 0 ? 1 : 0)}
                      width={140}
                      state={transcription === 0 ? false : true}
                      height={30}
                    />
                  </div>
                </div>
              </div>


              <div style={{ marginTop: 20 }} className="inputs">
                <div className="input">
                  <div className="flex items-center">
                    <span>Upload - Dialogflow file:</span>
                    <img id="upload-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting  " alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#upload-tp" content={`Please upload your Dialogflow file, remember must be a JSON file`} place="top" />
                  </div>
                  <label className="custom-file">
                    <input
                      onChange={(e) => { setNlp_config(e.target.files[0]); setNlp_configName(e.target.files[0].name) }}
                      type="file"
                      accept=".json"
                    />
                    {nlp_configName}
                  </label>
                </div>
              </div>



              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input " id="selectbox">
                  <div className="d-flex flex-row align-items-center justify-space-between w-100">
                    <span>Campaign:</span>
                    <select ref={campaingRef} className='select ml-3 select-nesting input-data ' onChange={(e) => { }} style={{ flexGrow: '2', backgroundPositionX: "96%", height:"100%" }}>
                      {campaings.map((item, i) => (
                        <option value={item.id}  >{item.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input " id="selectbox">
                  <div className="d-flex flex-row align-items-center justify-space-between w-100">
                    <span>Sub-campaign:</span>
                    <select ref={subCampaingRef} className='select ml-3 select-nesting input-data ' style={{ flexGrow: '2', backgroundPositionX: "96%", height:"100%" }} onChange={(e) => { }}>
                      {subCampaings.map((item, i) => (
                        <option value={item.id}  >{item.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

            </div>

            <div style={{ borderRight: '1px solid #bfbfbf' }}></div>

            <div className="d-flex flex-column" style={{ width: '45%', paddingRight: 20 }}>


            <div className="inputs" style={{ marginTop: 20 }}>
                <SelectNesting
                  ref={language} id="language"
                  boxInfo={true} tooltipText="Select language to project"
                  title="Language:" containerClass=" mr-2"
                  onChange={(e) => { fetchVoice() }}
                >  
                  {listLanguage.map((item, index) => (<option key={index} value={item.value}>{item.name}</option>))}
                </SelectNesting>
              </div>
              
           

              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input">
                  <div className="d-flex flex-row align-items-center justify-space-between w-100">
                    <span>Model Sentiment:</span>
                    <select onChange={ChangeModelSentiment} className='select ml-3 select-nesting input-data ' style={{ flexGrow: '2', backgroundPositionX: "96%" }}>
                      <option value="Phrase" selected={selectedProject.model_sentiment ? 'selected' : ''}>Phrase</option>
                      <option value="Voice" selected={!selectedProject.model_sentiment ? 'selected' : ''}>Voice</option>
                      <option value="Answer" selected={!selectedProject.model_sentiment ? 'selected' : ''}>Answer</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input">
                  <div className="d-flex flex-row align-items-center justify-space-between w-100">
                    <span>Bot Sentiment:</span>
                    <select onChange={saveBotSentimentConfig} className='select ml-3 select-nesting input-data ' style={{ flexGrow: '2', backgroundPositionX: "96%" }}>
                      <option value="1" selected={selectedProject.bot_sentiment !== 0 ? 'selected' : ''}>ON</option>
                      <option value="0" selected={selectedProject.bot_sentiment === 0 ? 'selected' : ''}>OFF</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* <div className="inputs" style={{marginTop: 20}}>
                <div className="input">
                  <div className='d-flex flex-row align-items-center w-100'>
                    <span style={{minWidth: 138}}>On-Hold Availability:</span>
                    <input
                         
                        defaultChecked={hold}
                        onChange={(e) => { setHold(!hold); }}
                        type="checkbox"
                        style={{marginLeft: 10, width: 'auto'}}
                    />
                  </div>
                </div>
              </div> */}

              <div className="d-flex flex-col  ">
                <div className="inputs" style={{ marginTop: 20 }}  >
                  <div className="input">
                    <div className='d-flex flex-column  '  >
                      <span>Minimun call durations (minutes):</span>
                      <input style={{ maxWidth: 113 }}
                        ref={minimunCallDurations}
                        className='  mt-1 input-data'
                        disabled={!hold}
                        type="number"
                      />
                    </div>
                  </div>
                </div>
                <div className="inputs" style={{ marginTop: 20 }}  >
                  <div className="input">
                    <div className='d-flex flex-column  '  >
                      <span>Max user response time (seconds):</span>
                      <input style={{ maxWidth: 113 }}
                        ref={maxUserResponseTime}
                        className=' mt-1 input-data'
                        disabled={!hold}
                        type="number"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="input">
                <div className='d-flex flex-col mt-3  w-100'>
                  <div className="flex items-center " style={{ marginBottom: "2%" }}>
                    <span style={{}}>On-Hold Availability:</span>
                    <img id="hold-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting  " alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#hold-tp" content={`This option allowed the possibility to put on hold our interaction during the call`} place="top" />
                  </div>
                  <ButtonYesNo
                    onClick={() => setHold((prev) => !prev)}
                    width={140}
                    state={hold}
                    height={30}
                  />
                </div>
              </div>

              <div className="d-flex flex-row align-items-center">
                <div className="inputs" style={{ marginTop: 20 }}  >
                  <div className="input">
                    <div className='d-flex flex-column align-items-center'  >
                      <span>Hold time (seconds):</span>
                      <input style={{ maxWidth: 113 }}
                        ref={timeHoldRef}
                        className='ml-3 mt-3 input-data'
                        disabled={!hold}
                        type="number"
                      />
                    </div>
                  </div>
                </div>

                <div className="inputs ml-2" style={{ marginTop: 20 }}>
                  <div className="input">
                    <div className='d-flex flex-column align-items-center w-100'>
                      <span style={{ marginRight: 50 }}>Hold attempts:</span>
                      <div className="d-flex flex-row align-items-center mt-2">
                        <input style={{ maxWidth: 113 }}
                          ref={timeHoldAmountRef}
                          className='ml-3 mt-3 input-data'
                          disabled={!hold}
                          type="number"
                        />
                        <span className="ml-2" style={{ whiteSpace: 'nowrap' }}>per call</span>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              {/* <div className="inputs" style={{ marginTop: 20 }}>
              <div className="input">
                <div className='d-flex flex-row align-items-center w-100'>
                  <span style={{ minWidth: 138 }}>Use random voices?</span>
                  <input
                    style={{ marginLeft: 10, width: 'auto' }}
                    defaultChecked={selectedProject.random_voice}
                    onChange={(e) => { setRadomVoice(!radomVoice); }}
                    type="checkbox"
                  />
                </div>
              </div>
            </div> */}
              <div className="inputs" style={{ marginTop: 20 }}  >
                <div className="input">
                  <div className='d-flex flex-row align-items-center   '  >
                    <span>Resolution time:</span>
                    <input style={{ maxWidth: 113 }}
                      ref={affectation_time_ref}
                      className='ml-3   input-data'
                      type="number"
                    />
                  </div>
                </div>
              </div>
              <div className="inputs" style={{ marginTop: 20 }}  >
                <div className="input">
                  <div className='d-flex flex-row align-items-center    '  >
                    <span>Percentage of affectation:</span>
                    <input style={{ maxWidth: 113 }}
                      ref={percentage_affectation_ref}
                      className='ml-3 input-data'
                      type="number"
                    />
                  </div>
                </div>
              </div>

              <div className="inputs" style={{ marginTop: 20 }}  >
                <div className="input">
                  <div className='d-flex flex-row align-items-center    '  >
                    <span>Reply time:</span>
                    <input style={{ maxWidth: 113 }}
                      ref={bot_respose_time_ref}
                      className='ml-3 input-data'
                      type="number"
                    />
                  </div>
                </div>
              </div>

              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input">
                  <div className='d-flex flex-col  w-100 mr-3' style={{ alignItems: "center", flexDirection: "row" }}>

                    <BoxInfo
                      id="ramvoice-tp"
                      titleClass='mr-0-4'
                      title="Use random voices?:"
                      place="top"
                      containerClass='mr-0-5 z-15'
                      content="When you activate this feature means that your bot going to select random voices when the call starts"
                    />
                    <ButtonYesNo
                      onClick={() => setRadomVoice((prev) => !prev)}
                      width={150}
                      state={radomVoice}
                      height={30}
                    />
                  </div>
                </div>
              </div>

              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input">
                  <div className="d-flex flex-row align-items-center justify-space-between w-100" >
                    <span></span>
                    <BoxInfo
                      id="selectv-tp"
                      titleClass='mr-0-4'
                      title="Select voice:"
                      place="top"
                      containerClass='mr-0-1 z-15'
                      content="Here you can choose your favorite voice between male and female and different accents"
                    />
                    <select className='select ml-2 select-nesting input-data ' style={{ flexGrow: '2', backgroundPositionX: "96%" }} id="voice">
                      {voices.map((item, index) => (
                        <option key={index} value={item.id}>{item.voice}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="inputs" style={{ marginTop: 25 }}>
                <div className="input d-flex flex-row align-items-center" style={{ alignItems: "center", flexDirection: "row" }}>
                  <span>Default for Sentiment:</span>
                  <div className="list_use_default_sentiment ml-2 d-flex flex-row align-items-center">
                    <ButtonYesNo
                      onClick={() => setUseDefaultSentiment((prev) => prev === 0 ? 1 : 0)}
                      width={150}
                      state={useDefaultSentiment === 0 ? false : true}
                      height={30}
                    />
                  </div>
                </div>
              </div>

            </div>

          </div>



          <div id="motor">
            {/*<div className="input">*/}
            {/*  <span>Motor:</span>*/}
            {/*  <div className="motor">*/}
            {/*    <input*/}
            {/*      {...register('motor', { required: true })}*/}
            {/*      type="radio"*/}
            {/*      id="motor_1"*/}
            {/*      value="1"*/}
            {/*    />*/}
            {/*    <label htmlFor="motor_1">*/}
            {/*      <span>Motor 1</span>*/}
            {/*    </label>*/}
            {/*    <input {...register('motor')} type="radio" id="motor_2" value="2" />*/}
            {/*    <label htmlFor="motor_2">*/}
            {/*      <span>Motor 2</span>*/}
            {/*    </label>*/}
            {/*  </div>*/}
            {/*</div>*/}
          </div>

          {/*<div className="inputs" id="metadata">*/}
          {/*  <div className="flex items-center justify-end">*/}
          {/*    <div className="upload-excel trans">*/}
          {/*      <img src="/icons/excel.svg" alt="newAns" /><label> Upload Excel</label>*/}
          {/*      <input type='file' accept='.xlsx, .xls' onChange={prepareExcel} />*/}
          {/*    </div>*/}
          {/*    <div className="input">*/}
          {/*      <a className="a-download trans" href={"/excel/FormatProjects.xlsx"} download >Download Template</a>*/}
          {/*    </div>*/}
          {/*    <div className="input">*/}
          {/*      <div onClick={() => { uploadMaxive() }} className="a-download upload-btn trans"   >*/}
          {/*        <div className='btn-loanding'>*/}
          {/*          {loadingUpload ? <Loading /> : <div>Upload Projects</div>}*/}
          {/*        </div>*/}

          {/*      </div>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*</div>*/}
          <div className="footer" style={{ marginTop: 30 }}>
            <div className='cont-buttons'>
              {errors.name?.type === 'required' ||
                errors.motor?.type === 'required' ||
                errors.metadata?.type === 'required' ? (
                <span style={{ color: "red" }}>All fields are required</span>
              ) : (
                <span> </span>
              )}
              <span className='errors-msg'  >{error.name}</span>
            </div>



          </div>
        </div>
        <div className='cont-buttons' style={{
          paddingRight: 20,
          width: '100%',
          justifyContent: 'flex-end',
          alignItems: 'flex-end',
          paddingTop: 12
        }}>
          <div className="buttons flex items-center" style={{ marginBottom: 20, }}>
            <button className="cancel btn-bottom btn-bottom-cancel" type="button" style={{ marginRight: 10, }} onClick={() => onClose()}>
              Cancel
            </button>
            <button className="create btn-bottom btn-bottom-create" type="submit" >
              Create
            </button>
          </div>
        </div>
      </form>
    </div>

  )
}
